var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-list"},[_c('img',{staticClass:"image",attrs:{"src":require("@/assets/images/cart-empty.png")}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }